import { Component, AfterContentInit, OnDestroy } from '@angular/core';
import { PlycaDataService } from '../../../services/plyca.service';
import { UIService } from '../../ui.service';
import { TimerDTO } from '../../api/plyca-dtos-v2';
import { PaginationDTO } from '../../api/PaginationModel';
import { HelpService, HelpType } from '../../components/common/help/help.service';
import { BaseComponent } from '../../components/common/baseComponent/base.component';
import { ConfirmationService } from 'primeng-lts/api';
import { TranslateService } from '@ngx-translate/core';



@Component({
  selector: 'timersPanel',
  templateUrl: 'timersPanel.template.html'
})
export class timersPanelComponent extends BaseComponent implements AfterContentInit, OnDestroy {
  loaded = false;
  timers: TimerDTO[] = [];
  // tslint:disable-next-line:no-construct
  public isActiveNode = new Boolean(true);
  constructor(
    public plycaService: PlycaDataService,
    public helpService: HelpService,
    public uiService: UIService,
    private confirmationService: ConfirmationService,
    private translateService: TranslateService,
  ) {
    super();
    this.subscribe(this.helpService.showContextHelpObservable(HelpType.SERVICES));
  }


  ngAfterContentInit(): void {
    this.loadTimers();
  }

  public isLoaded(): boolean {
    return this.loaded;
  }

  loadTimers() {
    this.loaded = false;
    this.subscribe(this.plycaService
      .getTimers(),
      (result: PaginationDTO<TimerDTO>) => {
        if (result.content) {
          this.timers = result.content;
        }
        this.loaded = true;
        // tslint:disable-next-line:triple-equals
        this.isActiveNode = undefined;
        if (this.timers != undefined) {
          this.isActiveNode = this.timers[0].activeNode;
        }
      });
  }

  updateTimerStatus(timer: TimerDTO, status: boolean) {
    this.subscribe(this.plycaService.updateTimerStatus(timer, status),
      () => this.loadTimers());
  }

}
